/**
 * start-data-export-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_START_DATA_EXPORT)
export class StartDataExportResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_START_DATA_EXPORT;

  @validateOpaqueID()
  public exportId : number;

  @validateAs("string")
  public token : string;

  @validateAs("string")
  public urlId : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/start-data-export-response.ts